/** When false, Apps dropdown and Apps entry in main/mobile nav stay in DOM but are hidden. */
export const SHOW_APPS_MAIN_MENU = false;

export function appsMainMenuHiddenClass(): string {
  return SHOW_APPS_MAIN_MENU ? "" : "hidden";
}
